(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lure-technology"] && !Shopify.designMode) return;
  try {
    
  function scrollToLureTechnology() {
    if (window.location.hash !== '#matieres-armement') return;
    const target = document.getElementById('matieres-armement');
    if (!target) return;
    [0, 250, 750].forEach((delay) => {
      window.setTimeout(() => {
        window.requestAnimationFrame(() => target.scrollIntoView({ block: 'start' }));
      }, delay);
    });
  }

  scrollToLureTechnology();
  window.addEventListener('load', scrollToLureTechnology);
  window.addEventListener('hashchange', scrollToLureTechnology);

  document.addEventListener('click', function(event) {
    const presentationLink = event.target.closest('a[href*="#matieres-armement"]');
    if (presentationLink) {
      window.setTimeout(scrollToLureTechnology, 0);
    }

    const trigger = event.target.closest('[data-infographic-trigger]');
    if (!trigger) return;
    const card = trigger.closest('[data-infographic]');
    if (!card) return;
    const targetId = trigger.getAttribute('data-infographic-trigger');
    card.querySelectorAll('[data-infographic-trigger]').forEach(function(item) {
      const active = item.getAttribute('data-infographic-trigger') === targetId;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    card.querySelectorAll('.lure-tech__panel').forEach(function(panel) {
      panel.hidden = panel.id !== targetId;
    });
  });

  document.addEventListener('keydown', function(event) {
    const trigger = event.target.closest('[data-infographic-trigger]');
    if (!trigger || !['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(event.key)) return;
    const group = trigger.closest('[role="tablist"]');
    if (!group) return;
    const tabs = Array.from(group.querySelectorAll('[data-infographic-trigger]'));
    const current = tabs.indexOf(trigger);
    const direction = event.key === 'ArrowLeft' || event.key === 'ArrowUp' ? -1 : 1;
    const next = tabs[(current + direction + tabs.length) % tabs.length];
    event.preventDefault();
    next.focus();
    next.click();
  });

  } catch(e) { console.error(e); }
})();
})();
